export default "__VITE_ASSET__CrUvMthk__"